import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Button, Input } from 'semantic-ui-react';
import i18next from 'i18next';
import { saveCompany, editEntityField } from '../../../actions';

class DeliveryEditor extends Component {
    handleSubmit = (event) => {
        this.props.saveCompany(this.props.entity);
        event.preventDefault();
    }

    render() {
        const company = this.props.entity || {};
        const deliveryInfo = company.deliveryInfo || { contact: {} };

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <label>{i18next.t('address')}</label>
                    <Input
                        fluid
                        placeholder={i18next.t('city')}
                        value={deliveryInfo.city || ''}
                        onChange={({ target }) => this.props.editEntityField('deliveryInfo.city', target.value)}
                    />
                </Form.Field>
                <Form.Field>
                    <Input
                        fluid
                        placeholder={i18next.t('street')}
                        value={deliveryInfo.street || ''}
                        onChange={({ target }) => this.props.editEntityField('deliveryInfo.street', target.value)}
                    />
                </Form.Field>
                <Form.Field>
                    <Input
                        fluid
                        placeholder={i18next.t('streetNumber')}
                        value={deliveryInfo.streetNumber || ''}
                        onChange={({ target }) => this.props.editEntityField('deliveryInfo.streetNumber', target.value)}
                    />
                </Form.Field>

                <Form.Field>
                    <Form.Group widths='equal'>
                        <Form.Field>
                            <label>{i18next.t('entrance')}</label>
                            <Input
                                fluid
                                placeholder={i18next.t('entrance')}
                                value={deliveryInfo.entrance || ''}
                                onChange={({ target }) => this.props.editEntityField('deliveryInfo.entrance', target.value)}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>{i18next.t('floor')}</label>
                            <Input
                                fluid
                                placeholder={i18next.t('floor')}
                                value={deliveryInfo.floor || ''}
                                onChange={({ target }) => this.props.editEntityField('deliveryInfo.floor', target.value)}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>{i18next.t('apartment')}</label>
                            <Input
                                fluid
                                placeholder={i18next.t('apartment')}
                                value={deliveryInfo.apartment || ''}
                                onChange={({ target }) => this.props.editEntityField('deliveryInfo.apartment', target.value)}
                            />
                        </Form.Field>
                    </Form.Group>
                </Form.Field>

                <Form.TextArea
                    label={i18next.t('comments')}
                    placeholder={i18next.t('comments')}
                    value={deliveryInfo.remarks || ''}
                    onChange={({ target }) => this.props.editEntityField('deliveryInfo.remarks', target.value)}
                />

                <Form.Field>
                    <label>{i18next.t('contact')}</label>
                    <Form.Group widths='equal'>
                        <Form.Field>
                            <Input
                                fluid
                                placeholder={i18next.t('name')}
                                value={deliveryInfo.contact.name || ''}
                                onChange={({ target }) => this.props.editEntityField('deliveryInfo.contact', { ...deliveryInfo.contact, name: target.value })}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Input
                                fluid
                                placeholder={i18next.t('phone')}
                                value={deliveryInfo.contact.phone || ''}
                                onChange={({ target }) => this.props.editEntityField('deliveryInfo.contact', { ...deliveryInfo.contact, phone: target.value })}
                            />
                        </Form.Field>
                    </Form.Group>
                </Form.Field>

                <Button primary type='submit' floated="right">
                    {i18next.t('save')}
                </Button>
            </Form>
        );
    }
}

DeliveryEditor.propTypes = {
    saveCompany: PropTypes.func,
    editEntityField: PropTypes.func,
    uploadImage: PropTypes.func,
    fetchCompanyDataFromGoogle: PropTypes.func,
    entity: PropTypes.object,
    
};

const mapStateToProps = (state) => {
    const { entity } = state.editor;

    return { entity };
};

export default connect(mapStateToProps, { saveCompany, editEntityField, })(DeliveryEditor);
